import AdminApplication from '@Admin/Core/AdminApplication';
import { MTAdminApplication } from '@Admin/Core/MTAdminApplication';
import Application from '@Common/ApplicationCore/Application';
import { ApplicationType } from '@Common/Enums';
import { MTApplication } from '@MTConsole/Core/MTApplication';
import { StudioApplication } from '@Studio/Core/StudioApplication';
import { TMApplication } from '@Themes/Core/TMApplication';

// tslint:disable-next-line:typedef
function getCurrentAppIf(type: ApplicationType, ...other: boolean[]) {
    return (target, prop) => {
        Object.defineProperty(target, prop, {
            get: () => {
                if (type === Application.current.id && !other.some(v => !!v)) {
                    return Application.current;
                }
                // tslint:disable-next-line:no-console
                console.warn('Incorrect appType:', prop, 'Current appType:', Application.current.id);
                return undefined;
            }
        });
    };
}

export abstract class ApplicationGuard {
    @getCurrentAppIf(ApplicationType.studio)
    public static studio: StudioApplication | undefined;

    @getCurrentAppIf(ApplicationType.admin)
    public static admin: AdminApplication | undefined;

    @getCurrentAppIf(ApplicationType.admin, altosoft.isMultiTenantAdminMode)
    public static mtAdmin: MTAdminApplication | undefined;

    @getCurrentAppIf(ApplicationType.themeManager)
    public static themeManager: TMApplication | undefined;

    @getCurrentAppIf(ApplicationType.tenant)
    public static mtConsole: MTApplication | undefined;

    public static is(...appTypes: ApplicationType[]): boolean {
        return appTypes.some(appType => Application.current.id === appType);
    }
}
